import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {CurrencyService} from '../../../general-services/service-currency-anagraf/currency.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-new-currency-anagraf',
  templateUrl: './new-currency-anagraf.component.html',
  styleUrls: ['./new-currency-anagraf.component.scss']
})
export class NewCurrencyAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  currency: CurrencyModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;
  id: number;
  currencyCod: string;

  constructor(private route: ActivatedRoute, private router: Router,
              private currencyService: CurrencyService, private _Activatedroute: ActivatedRoute) {
    super();

    this.currency = new CurrencyModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.currency.cod, [Validators.required]],
      description: [this.currency.description, [Validators.required]]
    });

    _Activatedroute.params.subscribe(params => {
      this.id = params['id'];
      this.currencyCod = params['cod'];
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.CURRENCY_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.currency.cod = this.formValidator.value.cod;
      this.currency.description = this.formValidator.value.description;
      this.saveSubscribe = this.currencyService.save(this.currencyService.baseUrl, this.currency).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Currency Cod already exists', 'Warning');
          } else {
            toastr.success('Currency with id ' + this.id + ' was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.CURRENCY_ANAGRF]);
          }
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}
